import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd/lib/grid';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import './style.scss';
import { Props } from './typing';
import InputField from '../../../../../../components/TextInput';
import DialCodePhoneInput from '../../../../../../components/DialCodePhoneInput';
import ProfileFooter from '../ProfileFooter';
import {
  emailValidationRegex,
  PANValidationRegex,
  selectedCountryPhoneRegex,
  alphabetValidationRegex,
} from 'lib/constants';
import imgURL from 'lib/imgURL';

const CompanyAuthDetails: FC<Props> = (props): JSX.Element => {
  const {
    nextPage,
    prevPage,
    currentStep,
    setCurrentStep,
    merchantProfile,
    updateProfileDetails,
    validationErrors,
  } = props;
  const [selectedCountry] = useState('India');
  const [showDirector2, setShowDirector2] = useState(
    merchantProfile?.companyauthdetails?.Director2_Name &&
      merchantProfile?.companyauthdetails?.Director2_Name !== ''
  );
  const selectedCountryRegex = selectedCountryPhoneRegex[selectedCountry];

  const formik = useFormik({
    initialValues: {
      Director1_Name: merchantProfile?.companyauthdetails?.Director1_Name || '',
      Director1_Email:
        merchantProfile?.companyauthdetails?.Director1_Email || '',
      Director1_PAN: merchantProfile?.companyauthdetails?.Director1_PAN || '',
      Director2_Name: merchantProfile?.companyauthdetails?.Director2_Name || '',
      Director2_Email:
        merchantProfile?.companyauthdetails?.Director2_Email || '',
      Director2_PAN: merchantProfile?.companyauthdetails?.Director2_PAN || '',
      RnD_Name: merchantProfile?.companyauthdetails?.RnD_Name || '',
      RnD_Mobile: merchantProfile?.companyauthdetails?.RnD_Mobile || '',
      RnD_Email: merchantProfile?.companyauthdetails?.RnD_Email || '',
      Settlements_Name:
        merchantProfile?.companyauthdetails?.Settlements_Name || '',
      Settlements_Mobile:
        merchantProfile?.companyauthdetails?.Settlements_Mobile || '',
      Settlements_Email:
        merchantProfile?.companyauthdetails?.Settlements_Email || '',
      Op_Name: merchantProfile?.companyauthdetails?.Op_Name || '',
      Op_Mobile: merchantProfile?.companyauthdetails?.Op_Mobile || '',
      Op_Email: merchantProfile?.companyauthdetails?.Op_Email || '',
    },
    validationSchema: Yup.object({
      Director1_Name: Yup.string()
        .matches(alphabetValidationRegex, validationErrors.INVALID_NAME)
        .trim(),
      Director1_Email: Yup.string()
        .matches(emailValidationRegex, validationErrors.INVALID_EMAIL)
        .trim(),
      Director1_PAN: Yup.string()
        .matches(PANValidationRegex, validationErrors.PAN_INVALID)
        .trim(),
      Director2_Name: Yup.string()
        .matches(alphabetValidationRegex, validationErrors.INVALID_NAME)
        .trim(),
      Director2_Email: Yup.string()
        .matches(emailValidationRegex, validationErrors.INVALID_EMAIL)
        .trim(),
      Director2_PAN: Yup.string()
        .matches(PANValidationRegex, validationErrors.PAN_INVALID)
        .trim(),
      RnD_Name: Yup.string()
        .matches(alphabetValidationRegex, validationErrors.INVALID_NAME)
        .trim(),
      RnD_Mobile: Yup.string()
        .matches(selectedCountryRegex, validationErrors.INVALID_PHONE)
        .trim(),
      RnD_Email: Yup.string()
        .matches(emailValidationRegex, validationErrors.INVALID_EMAIL)
        .trim(),
      Settlements_Name: Yup.string()
        .matches(alphabetValidationRegex, validationErrors.INVALID_NAME)
        .trim(),
      Settlements_Mobile: Yup.string()
        .matches(selectedCountryRegex, validationErrors.INVALID_PHONE)
        .trim(),
      Settlements_Email: Yup.string()
        .matches(emailValidationRegex, validationErrors.INVALID_EMAIL)
        .trim(),
      Op_Name: Yup.string()
        .matches(alphabetValidationRegex, validationErrors.INVALID_NAME)
        .trim(),
      Op_Mobile: Yup.string()
        .matches(selectedCountryRegex, validationErrors.INVALID_PHONE)
        .trim(),
      Op_Email: Yup.string()
        .matches(emailValidationRegex, validationErrors.INVALID_EMAIL)
        .trim(),
    }),
    onSubmit: () => {},
  });

  useEffect(() => {
    if (merchantProfile?.companyauthdetails) {
      formik.setValues({
        ...formik.values,
        Director1_Name:
          merchantProfile?.companyauthdetails?.Director1_Name || '',
        Director1_Email:
          merchantProfile?.companyauthdetails?.Director1_Email || '',
        Director1_PAN: merchantProfile?.companyauthdetails?.Director1_PAN || '',
        Director2_Name:
          merchantProfile?.companyauthdetails?.Director2_Name || '',
        Director2_Email:
          merchantProfile?.companyauthdetails?.Director2_Email || '',
        Director2_PAN: merchantProfile?.companyauthdetails?.Director2_PAN || '',
        RnD_Name: merchantProfile?.companyauthdetails?.RnD_Name || '',
        RnD_Mobile: merchantProfile?.companyauthdetails?.RnD_Mobile || '',
        RnD_Email: merchantProfile?.companyauthdetails?.RnD_Email || '',
        Settlements_Name:
          merchantProfile?.companyauthdetails?.Settlements_Name || '',
        Settlements_Mobile:
          merchantProfile?.companyauthdetails?.Settlements_Mobile || '',
        Settlements_Email:
          merchantProfile?.companyauthdetails?.Settlements_Email || '',
        Op_Name: merchantProfile?.companyauthdetails?.Op_Name || '',
        Op_Mobile: merchantProfile?.companyauthdetails?.Op_Mobile || '',
        Op_Email: merchantProfile?.companyauthdetails?.Op_Email || '',
      });
    }
  }, [merchantProfile?.companyauthdetails]);

  useEffect(() => {
    if (!showDirector2) {
      formik.setFieldValue('Director2_Name', '');
      formik.setFieldValue('Director2_Email', '');
      formik.setFieldValue('Director2_PAN', '');
    }
  }, [showDirector2]);

  const callFormSubmit = (step, statusData) => {
    const merchantProfileValue = {
      ...merchantProfile,
      companyauthdetails: {
        ...formik.values,
      },
    };
    updateProfileDetails(step, statusData, merchantProfileValue);
  };

  const enableSave = () => {
    return (
      Object.keys(formik.values).filter((key) => {
        return formik.values[key] !== '';
      }).length > 0
    );
  };

  const enableSaveAndNext = () => {
    return (
      formik.values.Director1_Name !== '' &&
      formik.values.Director1_Email !== '' &&
      formik.values.Director1_PAN !== '' &&
      formik.values.RnD_Name !== '' &&
      formik.values.RnD_Mobile !== '' &&
      formik.values.RnD_Email !== '' &&
      formik.values.Settlements_Name !== '' &&
      formik.values.Settlements_Mobile !== '' &&
      formik.values.Settlements_Email !== '' &&
      formik.values.Op_Name !== '' &&
      formik.values.Op_Mobile !== '' &&
      formik.values.Op_Email !== '' &&
      !(
        formik.errors.Director1_Name ||
        formik.errors.Director1_Email ||
        formik.errors.Director1_PAN ||
        formik.errors.RnD_Name ||
        formik.errors.RnD_Mobile ||
        formik.errors.RnD_Email ||
        formik.errors.Settlements_Name ||
        formik.errors.Settlements_Mobile ||
        formik.errors.Settlements_Email ||
        formik.errors.Op_Name ||
        formik.errors.Op_Mobile ||
        formik.errors.Op_Email
      )
    );
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className='kyc-company-authdetails'>
        <div className='title'>Company Auth Details</div>
        <Row>
          <Col span={10}>
            <div className='content-text'>
            </div>
          </Col>
        </Row>
        <div className='director-details'>
          <div className='dir-title'>Director’s Details</div>
          <div className='dir-content'>
          </div>
        </div>
        <div className='plural-company-director-details'>
          <Row>
            <Col span={6}>
              <InputField
                name='Director1_Name'
                type='text'
                label='Name'
                isRequired={true}
                value={formik.values.Director1_Name}
                placeholder='Name'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.Director1_Name && formik.errors.Director1_Name
                )}
                errorMessage={formik.errors.Director1_Name?.toString()}
              />
            </Col>
            <Col span={6} offset={1}>
              <InputField
                name='Director1_Email'
                type='email'
                label='Email'
                isRequired={true}
                value={formik.values.Director1_Email}
                placeholder='Email'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.Director1_Email &&
                    formik.errors.Director1_Email
                )}
                errorMessage={formik.errors.Director1_Email?.toString()}
              />
            </Col>
          </Row>

          <Row>
            <Col span={6}>
              <InputField
                name='Director1_PAN'
                type='text'
                label='PAN Number'
                isRequired={true}
                value={formik.values.Director1_PAN}
                placeholder='PAN Number'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.Director1_PAN && formik.errors.Director1_PAN
                )}
                errorMessage={formik.errors.Director1_PAN?.toString()}
              />
            </Col>
          </Row>
          {!showDirector2 && (
            <Row>
              <div
                className='add-director2'
                onClick={() => {
                  setShowDirector2(true);
                }}
              >
                <img src={imgURL['add-director']} alt='Add Director' />
                <label> ADD DIRECTOR</label>
              </div>
            </Row>
          )}

          <div className='divider' />
        </div>
        {showDirector2 && (
          <>
            <div className='director-details'>
              <Row>
                <Col span={9}>
                  <div className='dir-title'>Director 2 Details</div>
                  <div className='dir-content'>
                  </div>
                </Col>
                <Col span={6}>
                  <div
                    className='remove-director2'
                    onClick={() => {
                      setShowDirector2(false);
                    }}
                  >
                    <img
                      src={imgURL['remove-director']}
                      alt='Remove Director'
                    />
                    <label> REMOVE DIRECTOR</label>
                  </div>
                </Col>
              </Row>
            </div>

            <div className='plural-company-director-details'>
              <Row>
                <Col span={6}>
                  <InputField
                    name='Director2_Name'
                    type='text'
                    label='Name'
                    isRequired={true}
                    value={formik.values.Director2_Name}
                    placeholder='Name'
                    className='form-control'
                    onBlur={formik.handleBlur}
                    handleChange={formik.handleChange}
                    readonly={false}
                    error={Boolean(
                      formik.touched.Director2_Name &&
                        formik.errors.Director2_Name
                    )}
                    errorMessage={formik.errors.Director2_Name?.toString()}
                  />
                </Col>
                <Col span={6} offset={1}>
                  <InputField
                    name='Director2_Email'
                    type='email'
                    label='Email'
                    isRequired={true}
                    value={formik.values.Director2_Email}
                    placeholder='Email'
                    className='form-control'
                    onBlur={formik.handleBlur}
                    handleChange={formik.handleChange}
                    readonly={false}
                    error={Boolean(
                      formik.touched.Director2_Email &&
                        formik.errors.Director2_Email
                    )}
                    errorMessage={formik.errors.Director2_Email?.toString()}
                  />
                </Col>
              </Row>

              <Row>
                <Col span={6}>
                  <InputField
                    name='Director2_PAN'
                    type='text'
                    label='PAN Number'
                    isRequired={true}
                    value={formik.values.Director2_PAN}
                    placeholder='PAN Number'
                    className='form-control'
                    onBlur={formik.handleBlur}
                    handleChange={formik.handleChange}
                    readonly={false}
                    error={Boolean(
                      formik.touched.Director2_PAN &&
                        formik.errors.Director2_PAN
                    )}
                    errorMessage={formik.errors.Director2_PAN?.toString()}
                  />
                </Col>
              </Row>
              <div className='divider' />
            </div>
          </>
        )}

        <div className='risk-details'>
          <div className='dir-title'>Risk and Disputes’s Details</div>
          <div className='dir-content'>
          </div>
        </div>
        <div className='plural-company-risk-details'>
          <Row>
            <Col span={6}>
              <InputField
                name='RnD_Name'
                type='text'
                label='Name'
                isRequired={true}
                value={formik.values.RnD_Name}
                placeholder='Name'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.RnD_Name && formik.errors.RnD_Name
                )}
                errorMessage={formik.errors.RnD_Name?.toString()}
              />
            </Col>
            <Col span={6} offset={1}>
              <InputField
                name='RnD_Email'
                type='email'
                label='Email'
                isRequired={true}
                value={formik.values.RnD_Email}
                placeholder='Email'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.RnD_Email && formik.errors.RnD_Email
                )}
                errorMessage={formik.errors.RnD_Email?.toString()}
              />
            </Col>
          </Row>

          <Row>
            <Col span={6}>
              <DialCodePhoneInput
                placeholder='Enter your mobile no.'
                label='Phone Number'
                name='RnD_Mobile'
                isRequired={true}
                handleChange={(value) => {
                  formik.setFieldValue('RnD_Mobile', value);
                }}
                onBlur={formik.handleBlur}
                error={Boolean(
                  formik.touched.RnD_Mobile && formik.errors.RnD_Mobile
                )}
                errorMessage={formik.errors.RnD_Mobile?.toString()}
                value={formik.values.RnD_Mobile}
                country={'in'}
                onlyCountries={['in']}
                masks={{ in: '..........' }}
                countryCodeEditable={false}
              />
            </Col>
          </Row>
          <div className='divider' />
        </div>

        <div className='settlement-details'>
          <div className='dir-title'>Settlement&lsquo;s Details</div>
          <div className='dir-content'>
          </div>
        </div>
        <div className='plural-company-settlement-details'>
          <Row>
            <Col span={6}>
              <InputField
                name='Settlements_Name'
                type='text'
                label='Name'
                isRequired={true}
                value={formik.values.Settlements_Name}
                placeholder='Name'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.Settlements_Name &&
                    formik.errors.Settlements_Name
                )}
                errorMessage={formik.errors.Settlements_Name?.toString()}
              />
            </Col>
            <Col span={6} offset={1}>
              <InputField
                name='Settlements_Email'
                type='email'
                label='Email'
                isRequired={true}
                value={formik.values.Settlements_Email}
                placeholder='Email'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.Settlements_Email &&
                    formik.errors.Settlements_Email
                )}
                errorMessage={formik.errors.Settlements_Email?.toString()}
              />
            </Col>
          </Row>

          <Row>
            <Col span={6}>
              <DialCodePhoneInput
                placeholder='Enter your mobile no.'
                label='Phone Number'
                name='Settlements_Mobile'
                isRequired={true}
                handleChange={(value) => {
                  formik.setFieldValue('Settlements_Mobile', value);
                }}
                onBlur={formik.handleBlur}
                error={Boolean(
                  formik.touched.Settlements_Mobile &&
                    formik.errors.Settlements_Mobile
                )}
                errorMessage={formik.errors.Settlements_Mobile?.toString()}
                value={formik.values.Settlements_Mobile}
                country={'in'}
                onlyCountries={['in']}
                masks={{ in: '..........' }}
                countryCodeEditable={false}
              />
            </Col>
          </Row>
          <div className='divider' />
        </div>

        <div className='operation-details'>
          <div className='dir-title'>Operation&lsquo;s Details</div>
          <div className='dir-content'>
          </div>
        </div>
        <div className='plural-company-operation-details'>
          <Row>
            <Col span={6}>
              <InputField
                name='Op_Name'
                type='text'
                label='Name'
                isRequired={true}
                value={formik.values.Op_Name}
                placeholder='Name'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(formik.touched.Op_Name && formik.errors.Op_Name)}
                errorMessage={formik.errors.Op_Name?.toString()}
              />
            </Col>
            <Col span={6} offset={1}>
              <InputField
                name='Op_Email'
                type='email'
                label='Email'
                isRequired={true}
                value={formik.values.Op_Email}
                placeholder='Email'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.Op_Email && formik.errors.Op_Email
                )}
                errorMessage={formik.errors.Op_Email?.toString()}
              />
            </Col>
          </Row>

          <Row>
            <Col span={6}>
              <DialCodePhoneInput
                placeholder='Enter your mobile no.'
                label='Phone Number'
                name='Op_Mobile'
                isRequired={true}
                handleChange={(value) => {
                  formik.setFieldValue('Op_Mobile', value);
                }}
                onBlur={formik.handleBlur}
                error={Boolean(
                  formik.touched.Op_Mobile && formik.errors.Op_Mobile
                )}
                errorMessage={formik.errors.Op_Mobile?.toString()}
                value={formik.values.Op_Mobile}
                country={'in'}
                onlyCountries={['in']}
                masks={{ in: '..........' }}
                countryCodeEditable={false}
              />
            </Col>
          </Row>
          <div className='divider' />
        </div>
      </div>
      <ProfileFooter
        nextPage={nextPage}
        prevPage={prevPage}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        saveAction={callFormSubmit}
        enableSave={enableSave()}
        enableSaveAndNext={enableSaveAndNext()}
      />
    </form>
  );
};

const mapStateToProps = ({ validationReducer }) => ({
  validationErrors: validationReducer.validationErrorState.validationErrors,
});

export default connect(mapStateToProps, {})(CompanyAuthDetails);
